/* eslint-disable camelcase */
import Flex from 'common/components/Flex'
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import { useState } from 'react'
import styled from 'styled-components'

const Radio = styled.label`
  margin-top: 10px;
  margin-right: 20px;
  input[type='radio'] {
    display: none;
  }
  input[type='radio'] + *::before {
    content: '';
    display: inline-block;
    vertical-align: bottom;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border-style: solid;
    border-width: 0.1rem;
    border-color: ${theme.colors.grayLight};
    margin-right: 10px;
    cursor: pointer;
  }
  input[type='radio']:checked {
    color: orange;
  }
  input[type='radio']:checked + *::before {
    cursor: pointer;
    background: radial-gradient(
      ${theme.colors.orange} 0%,
      ${theme.colors.orange} 30%,
      transparent 40%,
      transparent
    );
  }
`

const OptionWrapper = styled.div`
  margin: 0 0 20px;
`

interface IRadioBullet {
  data: {
    id: string
    question: string
    answer_type: string
    options?: Array<{
      id: string
      option: string
      next_questions?: {
        url: string
        method: string
      }
    }>
  }
  defaultValue?: string
  onChange: (id: string, val: string) => void
}

function RadioBullet({
  onChange,
  data,
  defaultValue = '',
}: IRadioBullet): JSX.Element {
  const [value, setValue] = useState(defaultValue)

  const handleChange = (val) => {
    setValue(val.id)
    onChange(val, val.id)
  }

  return (
    <OptionWrapper data-testid="Option-Radio">
      <Typography>{data?.question}</Typography>
      <Flex>
        {data?.options &&
          data?.options.length > 0 &&
          data?.options.map((opt) => {
            return (
              <Radio key={opt.id}>
                <input
                  type="radio"
                  value={opt?.id}
                  onChange={() => handleChange(opt)}
                  checked={value === opt?.id}
                  data-testid={`radio-${opt?.option}`}
                />
                <Typography>{opt?.option}</Typography>
              </Radio>
            )
          })}
      </Flex>
    </OptionWrapper>
  )
}

export default RadioBullet
